import __vue_component__ from '../HseIcon/HseIcon.vue.js';
import __vue_component__$1 from '../../icons/action/check/IconActionCheck.vue.js';
import __vue_component__$2 from './HseCheckboxIconIndeterminate.vue.js';

//

/**
 * Базовая иконка чекбокса
 * ```vue live
 * <HseBaseCheckboxIcon checked />
 * ```
 */
var script = {
  name: 'HseBaseCheckboxIcon',
  components: {
    HseIcon: __vue_component__
  },
  props: {
    /**
     * Выбранное состояние
     */
    checked: {
      type: Boolean,
      default: false
    },
    /**
     * Неопределенное состояние
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Неактивное состояние
     */
    inactive: {
      type: Boolean,
      default: false
    },
    /**
     * Радио-кнопка
     */
    radio: {
      type: Boolean,
      default: false
    },
    /**
     * Сфокусированное состояние
     */
    focused: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    IconActionCheck: __vue_component__$1,
    HseCheckboxIconIndeterminate: __vue_component__$2
  })
};

export default script;
